import { FREE, TRIAL } from 'Types/plan';
import { DateTime } from 'luxon';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';

import { useSetUpBilling } from 'App/components/Client/Billing/useSetUpBilling';
import { useStore } from 'App/mstore';

import { RecordingsMeter as Meter } from 'Shared/RecordingsMeter/RecordingsMeter';

/** SaaS: recordings captured this period against the free or trial allowance, at the foot of the side nav.
 *  A paid plan shows nothing. */
function RecordingsMeter() {
  const { billingStore, userStore } = useStore();
  const { isLoggedIn } = userStore;
  const setUpBilling = useSetUpBilling();

  useEffect(() => {
    if (isLoggedIn && !billingStore.planFetched && !billingStore.loading) {
      // the meter is optional; a plan that can't be read just leaves it out
      billingStore.fetchPlan().catch(() => {});
    }
  }, [isLoggedIn]);

  if (!billingStore.planFetched) return null;
  const plan = billingStore.instance;
  const type = plan.current.type;
  if ((type !== FREE && type !== TRIAL) || plan.hasActivePlan) return null;
  const included = plan.current.recordedSessions ?? 0;
  if (!included) return null;
  const trialDays =
    userStore.account.plan?.remainingTrialDays ?? plan.remaining.trial ?? 0;
  // the trial's allowance lasts until the trial ends; the free one is monthly,
  // and without a billing date the calendar month is the period
  const resetsOn = (
    type === TRIAL && trialDays > 0
      ? DateTime.now().plus({ days: trialDays })
      : (plan.billing.nextBillingDate ??
        DateTime.now().startOf('month').plus({ months: 1 }))
  ).toFormat('LLL dd');

  return (
    <Meter
      captured={plan.count.capturedSessions ?? 0}
      included={included}
      resetsOn={resetsOn}
      onUpgrade={setUpBilling}
    />
  );
}

export default observer(RecordingsMeter);
